import styled from 'styled-components';
import { mediaBreakpointDown, mediaBreakpointUp } from 'utils/styledCssHelpers';

export const SPostSocials = styled.div`
  margin: 20px 0px;
  display: inline-flex;
  flex-wrap: wrap;
  span {
    margin-right: 1rem;
    &::last-of-type {
      margin-right: 0;
    }
  }
  transform: * 0.8s;
  ${mediaBreakpointUp(
    'lg',
    `
  &.stick-left {
    position: fixed;
    left: 0;
    right: 0;
    display: flex;
    flex-direction: column;

    & .text {
      display: none;
    }
    & .share-icon {
      margin-right: 0px;
      width: 50px;

      &:hover {
        width: 70px;
        transform: width 0.2s ease-out;
      }
    }
  }
  `,
  )}
`;

export const SPostSocialBtn = styled.a`
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: ${props => props.bg};
  color: $ffffff !important;
  padding: 10px 15px;
  margin-right: 10px;
  margin-bottom: 10px;
  &:last-of-type {
    margin-right: 0;
  }
  span {
    margin-left: 15px;
    color: #ffffff !important;
    font-size: 13px;
    margin-bottom: 2px;
    ${mediaBreakpointDown(
      'md',
      `
      display:none;
    `,
    )}
`;
